exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background[data-v-aba443f8]{padding-top:14px}\n", ""]);

// exports
